import React, { useState, useEffect } from "react";
import { Box, Chip, IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DataTable from "@/components/dataTableComponents/DataTable";
import {
  useFetchShiftMasterQuery,
  useDeleteShiftMutation,
} from "@/api/services/attendanceMaster/ShiftMaster";
import CommonDataTable from "@/components/dataTableComponents/NewDatatable";
import ShiftForm from "./ShiftForm";
import withDialogState from "@/hoc/withDialogState";
import { CustomAlert } from "@/components";
import { toast } from "@/components/toastify";
import StatusChip from "@/components/table/chip";

const EnhancedShiftForm = withDialogState(ShiftForm);

function ShiftMasterGrid() {
  const { data: rowDetails = [], refetch } = useFetchShiftMasterQuery();
  const rows = rowDetails?.data || [];
  const [open, setOpen] = useState(false);  
  const [deleteShift] = useDeleteShiftMutation();

  const [openDeletePopUp, setOpenDeletePopUp] = useState(false);
  const deleteClose = () => setOpenDeletePopUp(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };

  const handleDeleteClick1 = (row) => {
    setSelectedRow(row);
    deleteShift({ id: row.id });
  };

  const handleDeleteClick = (row) => {
    setSelectedRow({
      id: row.id,
    });
    setOpenDeletePopUp(true);
  };

  const handleDeletePopUpSubmit = async () => {
    if (!selectedRow) return;
    try {
      await deleteShift({
        id: selectedRow?.id,
      }).unwrap();
      toast("success", "Shift Row Deleted Successfully");
      await refetch();
      setOpenDeletePopUp(false);
      setSelectedRow(null);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setOpenDeletePopUp(false);
    setSelectedRow(null);
  };

  const renderCellWithNewlines = (value) => (
    <Box sx={{ whiteSpace: "pre-line" }}>{value}</Box>
  );

  const columns = [
    { field: "shiftCode", headerName: "Shift Code", flex: 1 },
    { field: "shiftName", headerName: "Shift Name", flex: 1 },
    {
      field: "inTime",
      headerName: "Shift In Time",
      flex: 1,
      renderCell: (params) => renderCellWithNewlines(params.value || "-"),
    },
    {
      field: "outTime",
      headerName: "Shift Out Time",
      flex: 1,
      renderCell: (params) => renderCellWithNewlines(params.value || "-"),
    },
    {
      field: "halfDayTime",
      headerName: "Half Day Time",
      flex: 1,
      renderCell: (params) => renderCellWithNewlines(params.value || "-"),
    },
    {
      field: "fullDayTime",
      headerName: "Full Day Time",
      flex: 1,
      renderCell: (params) => renderCellWithNewlines(params.value || "-"),
    },
    {
      field: "graceTime",
      headerName: "Grace Time",
      flex: 1,
      renderCell: (params) => renderCellWithNewlines(params.value || "-"),
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => (
        <StatusChip
          label={params.row.status === true ? "Active" : "Inactive"}
          colorchip={params.row.status === true ? "#17B26A" : "red"}
          backgroundColor={params.row.status === true ? "#ECFDF3" : "#FEF3F2"}
          dotColor={params.row.status === true ? "#17B26A" : "#F04438"}
          borderColor={params.row.status === true ? "#ABEFC6" : "#FECDCA"}
        />
      ),
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      renderCell: (params) => (
        <Box display="flex" alignItems={"center"} height={"100%"}>
          <IconButton
            onClick={() => handleDeleteClick(params.row)}
            sx={{ color: "#A5A1A1" }}
          >
            <DeleteIcon />
          </IconButton>
          <IconButton
            onClick={() => handleEditClick(params.row)}
            sx={{ color: "#A5A1A1" }}
          >
            <EditIcon />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", p: 0 }}>
      <CommonDataTable
        columns={columns}
        rows={rows}
        tableTitle="Shift Master"
        search={true}
      />

      <EnhancedShiftForm
        open={open}
        setOpen={setOpen}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        refetch={refetch}
      />

      <CustomAlert
        open={openDeletePopUp}
        title="Delete Request"
        message="Are you sure you want to delete this row?"
        onCancel={deleteClose}
        onSubmit={handleDeletePopUpSubmit}
        cancelText="Cancel"
        submitText="Submit"
      />
    </Box>
  );
}

// export default ShiftMasterGrid;
export default withDialogState(ShiftMasterGrid);
